import { CardComponentProps } from "../../../types/types";
import styles from "./Placeholder.module.scss";

export function StoryPlaceholder({
  configProps,
}: Pick<CardComponentProps, "configProps">) {
  return (
    <div
      className={styles.placeholder}
      data-component="StoryPlaceholder"
      style={{
        ...(configProps?.height
          ? { height: configProps?.height as number }
          : {}),
      }}
    >
      {(configProps?.label as string) || "Slot"}
    </div>
  );
}
